import axios from 'axios';
import { getTranslationKeys } from '../translations';
export var getProductInfoDialogTranslations = async function getProductInfoDialogTranslations(_ref) {
  var currentLanguage = _ref.currentLanguage,
    translationsUrl = _ref.translationsUrl;
  var url = new URL('/system/ajax/Localization/Translate', translationsUrl);
  url.searchParams.set('sc_lang', currentLanguage);
  getTranslationKeys().forEach(function (key) {
    return url.searchParams.append('keys', key);
  });
  var _await$axios$get = await axios.get(url.toString()),
    data = _await$axios$get.data;
  return data;
};